"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBreakpoints = void 0;
const keys = ["xs", "sm", "md", "lg", "xl"];
function createBreakpoints(breakpoints = {}) {
    const values = {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        ...breakpoints,
    };
    function getMinBreakpoint(key) {
        return typeof key === "number" ? key : values[key];
    }
    function getMaxBreakpoint(key) {
        if (typeof key === "number") {
            return key - 0.02;
        }
        const nextIndex = keys.indexOf(key) + 1;
        const nextKey = keys[nextIndex];
        return getMinBreakpoint(nextKey) - 0.02;
    }
    function up(key) {
        return `@media (min-width: ${getMinBreakpoint(key)}px)`;
    }
    function down(key) {
        const max = getMaxBreakpoint(key);
        if (Number.isNaN(max)) {
            return up("xs");
        }
        return `@media (max-width: ${max}px)`;
    }
    function between(lower, upper) {
        const min = getMinBreakpoint(lower);
        const max = getMaxBreakpoint(upper);
        if (Number.isNaN(max)) {
            return up(min);
        }
        return `@media (min-width: ${min}px) and (max-width: ${max}px)`;
    }
    function only(key) {
        return between(key, key);
    }
    function getWidth(key) {
        return typeof key === "string" ? values[key] : key;
    }
    return {
        breakpoints: {
            values,
            between,
            down,
            getWidth,
            only,
            up,
        },
    };
}
exports.createBreakpoints = createBreakpoints;
exports.default = createBreakpoints;
//# sourceMappingURL=data:application/json;base64,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